import {
  GetMaterialsListAuditLogsInput,
  GetMaterialsListOrderSummaryItemsInput,
  GetMaterialsListOrderSummaryItemsSortBy,
  OrderStatus,
  SortDirection,
} from '@/gql/graphql';
import { debounce } from 'lodash-es';
import { useState } from 'react';

export const usePaginationState = (pageSize: number) => {
  const [currentPage, setCurrentPage] = useState(1);

  return {
    pagination: {
      offset: (currentPage - 1) * pageSize,
      limit: pageSize,
    },
    setCurrentPage,
  };
};

export const useAuditLogsInputPaginationState = (pageSize: number) => {
  const { pagination, ...paginationActions } = usePaginationState(pageSize);
  const [input, setInput] = useState<GetMaterialsListAuditLogsInput>({});

  return {
    reset: () => {
      setInput({});
      paginationActions.setCurrentPage(1);
    },
    pagination,
    ...paginationActions,
    input,
    setSearchTerm: debounce((searchTerm?: string) => {
      setInput({ ...input, searchTerm });
      paginationActions.setCurrentPage(1);
    }, 300),
    setActingUserIds: (actingUserIds?: string[]) => {
      setInput({ ...input, actingUserIds });
      paginationActions.setCurrentPage(1);
    },
  };
};

export const useSummaryItemsInputPaginationState = (
  pageSize: number,
  defaultInputState?: GetMaterialsListOrderSummaryItemsInput
) => {
  const { pagination, ...paginationActions } = usePaginationState(pageSize);
  const [input, setInput] = useState<GetMaterialsListOrderSummaryItemsInput>(
    defaultInputState || {}
  );

  return {
    reset: () => {
      setInput(defaultInputState || {});
      paginationActions.setCurrentPage(1);
    },
    pagination,
    ...paginationActions,
    input,
    setSearchTerm: debounce((searchTerm?: string) => {
      setInput({ ...input, searchTerm });
      paginationActions.setCurrentPage(1);
    }, 300),
    setStatuses: (statuses?: OrderStatus[]) => {
      setInput({ ...input, statuses });
      paginationActions.setCurrentPage(1);
    },
    setSort: (
      sortBy?: GetMaterialsListOrderSummaryItemsSortBy,
      sortDirection?: SortDirection
    ) => {
      setInput({ ...input, sortBy, sortDirection });
      paginationActions.setCurrentPage(1);
    },
  };
};
